import { DealerPages } from 'components/DealerPage/DealerPage';

type CommonSeoProps = {
  page: DealerPages;
  name: string;
  address: string;
};

type SeoTitleProps = CommonSeoProps & {
  seoDisplayName: string;
};

type SeoDescriptionProps = CommonSeoProps & {
  seoCategoryDisplayName: string;
};
const getSeoTitle = (props: SeoTitleProps) => {
  const { page, name, seoDisplayName, address } = props;
  switch (page) {
    case DealerPages.our_stock:
      return `${name} | ${seoDisplayName} in ${address} - DoneDeal`;
    case DealerPages.contact:
      return `Contact ${name} | ${seoDisplayName} in ${address} - DoneDeal`;
    case DealerPages.reviews:
      return `${name} Reviews | ${seoDisplayName} in ${address} - DoneDeal`;
  }
};

const getSeoDescription = (props: SeoDescriptionProps) => {
  const { page, name, seoCategoryDisplayName, address } = props;
  switch (page) {
    case DealerPages.our_stock:
      return `Discover All ${seoCategoryDisplayName} for Sale from ${name}, Independent Dealer in ${address} on DoneDeal, Ireland's Largest Motor Marketplace.`;
    case DealerPages.contact:
      return `Contact ${name}, Independent Dealer in ${address} on DoneDeal, Ireland's Largest Motor Marketplace.`;
    case DealerPages.reviews:
      return `${name} Reviews | Independent Dealer in ${address} on DoneDeal, Ireland's Largest Motor Marketplace.`;
  }
};

export { getSeoTitle, getSeoDescription };
